<script setup>
import AssetsSelect from '@/views/experimental/map-view/AssetsSelect.vue';
import { customCss } from '@/views/experimental/table-view/quasar.js';
import { useStyleTag } from '@vueuse/core';
import { ref, onMounted, onUnmounted } from 'vue';
const { id, css, load, unload } = useStyleTag(customCss, { id: 'nabuto' });

onUnmounted(() => {
  unload();
});
</script>
<template>
  <vx-card no-shadow>
    <vs-popup
      fullscreen
      :title="popupTitle"
      :active.sync="popupActive"
      v-if="meta != null"
      style="z-index: 99999"
    >
      <b>Tracking Unit Configuration</b>
      <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <!-- <ejs-multiselect
            id="multiselect"
            :dataSource="unitSelection"
            maximumSelectionLength="1"
            v-model="meta.selectedUnit"
            :fields="unitFields"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="true"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            placeholder="Select"
            :filtering="unitFiltering"
          ></ejs-multiselect>
          {{ meta.selectedUnit }} -->
          <AssetsSelect
            @selected="
              (v) => {
                // $emit('selected', v);
                meta.selectedUnit = v;
              }
            "
            :style="{ width: `500px` }"
            ref="assetSelect"
            :dataSource="unitSelection"
            :filtering="unitFiltering"
            :f="unitFields"
            :singleSelect="true"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="Registration Number"
            label-placeholder="Vessel Name"
            v-model="meta.name"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <hr />
      <b>Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Registration Number"
            label-placeholder="Registration Number"
            v-model="meta.registration_number"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="Owner of Vessel"
            label-placeholder="Owner of Vessel"
            v-model="meta.owner"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            name="remarks"
            label-placeholder="Remarks"
            v-model="meta.remarks"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <hr />
      <b>Measurements</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Length (Meters)"
            label-placeholder="Length (Meters)"
            v-model="meta.length"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Breadth (Meters)"
            label-placeholder="Breadth (Meters)"
            v-model="meta.breadth"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Depth (Meters)"
            label-placeholder="Depth (Meters)"
            v-model="meta.depth"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Gross Tonnage (Tonnes)"
            label-placeholder="Gross Tonnage (Tonnes)"
            v-model="meta.tonnage"
            class="w-full"
          />
        </div>
        <br />
      </div>
      <hr />
      <b>Engines</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFieldsZones"
            v-model="meta.engineType"
            :dataSource="parameterOptionsEngines"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Engine Type"
            maximumSelectionLength="1"
          ></ejs-multiselect>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Number of Engine(s)"
            label-placeholder="Number of Engine(s)"
            v-model="meta.numberOfEngines"
            class="w-full"
          />
        </div>

        <br />
      </div>
      <hr />
      <br />
      <b>Annual Fee</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Expiry Date"
            type="date"
            label-placeholder="Expiry Date"
            v-model="meta.annual_fee"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label>Reminder</label>
          <vs-switch v-model="meta.annual_fee_reminder">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <b>Sea Worthiness / Safety Certificate</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Issuing Authority"
            label-placeholder="Issuing Authority"
            v-model="meta.issuing_authority"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Issue Date"
            type="date"
            label-placeholder="Issue Date"
            v-model="meta.certificate_issue_date"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Expiry Date"
            type="date"
            label-placeholder="Expiry Date"
            v-model="meta.certificate_expiry_date"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label>Reminder</label>
          <vs-switch v-model="meta.certificate_reminder">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>

        <br />
      </div>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Number of Crew"
            label-placeholder="Number of Crew"
            v-model="meta.number_of_crew"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <br />
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFieldsZones"
            v-model="meta.zones"
            :dataSource="parameterOptionsZones"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Approved Zones"
          ></ejs-multiselect>
        </div>
        <br />
      </div>
      <hr />
      <br />
      <b>Usage & Pictures</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <br />
          <ejs-multiselect
            id="multiselect"
            :fields="parameterFieldsUses"
            v-model="meta.uses"
            :dataSource="parameterOptionsUses"
            showClearButton="false"
            popupHeight="400px"
            mode="CheckBox"
            enableGroupCheckBox="false"
            showDropDownIcon="true"
            allowFiltering="true"
            filterType="contains"
            filterBarPlaceholder="Search"
            showSelectAll="false"
            placeholder="Use of the Vessel"
          ></ejs-multiselect>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label for="myvueDropZone">Upload Pictures</label>
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-success="
              (files, response) =>
                fileUploaderLocal(files, response, 'pictures')
            "
            v-on:vdropzone-removed-file="
              (file) => fileRemoverLocal(file, 'pictures')
            "
          ></vue-dropzone>
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <label for="myvueDropZone">Uploaded File(s)</label>
          <div class="row" :key="index" v-for="(item, index) in meta.pictures">
            <a
              :href="'https://api.igeotechgps.com/uploads/' + item"
              target="_blank"
              >{{ sanitizeLink(item) }}</a
            >
            &nbsp;
            <vs-button
              class="mb-base mr-3"
              size="small"
              type="border"
              icon-pack="feather"
              icon="icon icon-trash"
              @click="fileRemoverCloud('pictures', index)"
            ></vs-button>
          </div>
        </div>
      </div>

      <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Notification Channels</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addContact('add')"
            >Add Channel</vs-button
          >
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button
            color="primary"
            size="small"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="showChannels()"
            >Select from Existing Channels</vs-button
          >
        </div>
      </div>
      <br />
      <div v-if="showExistingChannels">
        <div class="vx-row">
          <div class="vx-col md:w-1/8 w-half">
            <b>Current Channels</b>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <vs-table stripe :data="existingChannels" max-height="500">
              <template slot="thead">
                <vs-th width="5%">No.</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Detail</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      <b>{{ indextr + 1 }}.</b></span
                    >
                  </vs-td>
                  <vs-td>
                    {{ tr.type }}
                  </vs-td>
                  <vs-td>
                    {{ tr.detail }}
                  </vs-td>
                  <vs-td>
                    {{ tr.remark }}
                  </vs-td>
                  <vs-td>
                    <vs-button
                      color="success"
                      type="border"
                      icon-pack="feather"
                      icon="icon-check"
                      @click="addContactExisting(indextr)"
                      >Add</vs-button
                    >
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col md:w-1/3 w-full"></div>
          <br />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-2/3 w-full">
          <vs-table stripe :data="meta.channels" max-height="500">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Detail</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span
                  >
                </vs-td>
                <vs-td>
                  <v-select
                    placeholder="Select Type"
                    clearable="false"
                    :options="['Telegram', 'Email', 'SMS']"
                    v-model="meta.channels[indextr].type"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.channels[indextr].detail"
                    label-placeholder="Details"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-input
                    v-model="meta.channels[indextr].remark"
                    label-placeholder="Remarks"
                    class="w-full"
                  />
                </vs-td>
                <vs-td>
                  <vs-button
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="removeContact(indextr)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />
      <hr />
      <br />
      <b>Notification Configuration</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="First Reminder"
            label-placeholder="First Reminder - Number of Days"
            v-model="meta.reminder_one_days"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Second Reminder"
            label-placeholder="Second Reminder - Number of Days"
            v-model="meta.reminder_two_days"
            class="w-full"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="First Reminder"
            label-placeholder="First Reminder - Nautical Miles Travelled"
            v-model="meta.reminder_one_mileage"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="Second Reminder"
            label-placeholder="Second Reminder - Nautical Miles Travelled"
            v-model="meta.reminder_two_mileage"
            class="w-full"
          />
        </div>
      </div>
      <br />
      <vs-button
        v-if="mode == 'add'"
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="postData('add')"
        >Add New Vessel</vs-button
      >
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Profile: <b>{{ meta.create_time }}</b>
          </div>
          <div class="vx-col md:w-1/4 w-half" v-if="meta.update_time != null">
            Last Updated : <b>{{ meta.update_time }}</b>
          </div>
        </div>
        <br />

        <br /><br />
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-pen"
              @click="postData('update')"
              >Update Vessel Profile</vs-button
            >
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"
              @click="postData('delete')"
              >Delete Vessel Profile</vs-button
            >
          </div>
        </div>
      </div>

      <br />
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <div class="vx-row">
      <div class="vx-col md:w-2/3 w-half">
        <vs-button size="small" @click="addTemplate">Add New Vessel</vs-button>
      </div>
      <div class="vx-col md:w-1/3 w-half">
        <vs-button size="small" @click="navigatePublic"
          >View Public Tracking</vs-button
        >
      </div>
    </div>

    <br />

    <ejs-grid
      :dataSource="templateData"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :allowTextWrap="true"
      height="40vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :searchSettings="searchOptions"
      :toolbar="toolbarOptions"
      ref="vesselTemplateGrid"
      id="vesselTemplateGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column
          field="no"
          headerText="No."
          textAlign="Left"
          width="80"
        ></e-column>
        <e-column
          field="name"
          headerText="Name"
          textAlign="Left"
          width="150"
        ></e-column>
        <e-column
          headerText="Picture"
          textAlign="Left"
          :template="cTemplate2"
          width="105"
        ></e-column>
        <e-column
          field="update_time"
          headerText="Last Updated"
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column
          field="owner"
          headerText="Manager"
          textAlign="Left"
          width="100"
        ></e-column>
        <e-column
          headerText="Manage"
          textAlign="Left"
          :template="cTemplate"
          width="100"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate1.vue';
import columntempVue2 from './editButtonTemplate2.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    vueDropzone: vue2Dropzone,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      unitFields: {
        groupBy: 'assetGroup',
        text: 'assetName',
        value: 'assetId',
      },
      selectedUnit: null,
      isLoading: false,
      mode: 'add',
      popupActive: false,
      popupTitle: 'Add New Vessel',
      templateData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${JSON.parse(localStorage.getItem('userInfo')).displayName} | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      meta: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      cTemplate2() {
        return { template: columntempVue2 };
      },
      showExistingChannels: false,
      existingChannels: [],
      parameterFieldsZones: { text: 'label', value: 'val' },
      parameterFieldsUses: { text: 'label', value: 'val' },
      parameterOptionsEngines: [
        {
          val: 'outboard',
          label: 'Outboard',
        },
        {
          val: 'inboard',
          label: 'Inboard',
        },
      ],
      parameterOptionsZones: [
        {
          val: 'North',
          label: 'North',
        },
        {
          val: 'South',
          label: 'South',
        },
        {
          val: 'Central',
          label: 'Central',
        },
        {
          val: 'West',
          label: 'West',
        },
        {
          val: 'East',
          label: 'East',
        },
      ],
      parameterOptionsUses: [
        {
          val: 'Defence',
          label: 'Defence',
        },
        {
          val: 'Patrol',
          label: 'Patrol',
        },
        {
          val: 'Cargo',
          label: 'Cargo',
        },
        {
          val: 'Tugs',
          label: 'Tugs',
        },
        {
          val: 'Passenger',
          label: 'Passenger',
        },
        {
          val: 'Fishing',
          label: 'Fishing',
        },
        {
          val: 'Roll-on Roll-Off',
          label: 'Roll-on Roll-Off',
        },
        {
          val: 'Sailboat',
          label: 'Sailboat',
        },
        {
          val: 'Yacht',
          label: 'Yacht',
        },
        {
          val: 'Dredgers',
          label: 'Dredgers',
        },
      ],
      parameterOptionsChannels: [
        {
          val: 'Telegram',
          label: 'Telegram',
        },
        {
          val: 'Email',
          label: 'Email',
        },
      ],
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  computed: {},
  methods: {
    navigatePublic() {
      window.open('https://fleets.igeotechgps.com/vms-public', '_blank');
    },
    fileUploaderLocal(files, response, key) {
      const x = response.path;
      const str = x.substring(25);
      this.meta[key].push(str);
    },
    fileRemoverCloud(key, index) {
      const self = this;
      self.meta[key].splice(index, 1);
    },
    fileRemoverLocal(file, key) {
      const self = this;
      const removedFile = file.upload.filename;
      const arr = self.meta[key];
      if (arr.length == 1) {
        self.meta[key] = [];
        return;
      }
      arr.forEach((element, i) => {
        const y = element.split('_', 4);
        if (y[3].includes(removedFile)) {
          self.meta[key].splice(i, 1);
        }
      });
    },
    sanitizeLink(link) {
      const y = link.split('_', 4);
      return `-> ${y[3]}`;
    },
    unitFiltering(args) {
      const self = this;
      const searchData = self.unitSelection;
      let query = new Query();
      let predicate = new Predicate('assetName', 'contains', args.text, true);
      predicate = predicate.or('assetGroup', 'contains', args.text, true);
      query = args.text != '' ? query.where(predicate) : query;

      args.updateData(searchData, query);
    },
    showChannels() {
      this.showExistingChannels = !this.showExistingChannels;
    },
    removeContact(index) {
      this.meta.channels.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Channel',
        color: 'success',
      });
    },
    addContact() {
      this.meta.channels.push({ type: '', detail: '', remark: '' });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Channel',
        color: 'success',
      });
    },
    addContactExisting(index) {
      this.meta.channels.push({
        type: this.existingChannels[index].type,
        detail: this.existingChannels[index].detail,
        remark: this.existingChannels[index].remark,
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Existing Channel',
        color: 'success',
      });
    },
    validateTemplate() {
      const self = this;
      return new Promise((resolve, reject) => {
        // console.log(self.meta);
        if (self.meta.selectedUnit == null) {
          reject('Tracking unit assignment is mandatory. Select to continue.');
        }
        if (self.meta.name.length < 5) {
          reject('Name field is mandatory. Minimum 5 characters.');
        }
        if (self.meta.registration_number.length < 3) {
          reject(
            'Registration Number field is mandatory. Minimum 3 characters.',
          );
        }
        if (self.meta.engineType == null) {
          reject('Engine Type field is mandatory. Select to continue.');
        }
        if (self.meta.numberOfEngines < 1) {
          reject('Number of Engines must be more than 0.');
        } else resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Vessel';
      self.meta = {
        selectedUnit: null,
        name: '',
        registration_number: '',
        owner: '',
        remarks: '',
        length: 0,
        depth: 0,
        breadth: 0,
        tonnage: 0,
        engineType: null,
        numberOfEngines: 0,
        annual_fee: null,
        annual_fee_reminder: true,
        issuing_authority: '',
        certificate_issue_date: null,
        certificate_expiry_date: null,
        certificate_reminder: true,
        number_of_crew: 0,
        zones: null,
        uses: null,
        pictures: [],
        reminder_one_days: 15,
        reminder_two_days: 7,
        reminder_one_mileage: 0,
        reminder_two_mileage: 0,
        channels: [],
        createdById: self.userInfo.uid,
        createdByMeta: {
          uid: JSON.parse(localStorage.getItem('userInfo')).uid,
          email: JSON.parse(localStorage.getItem('userInfo')).email,
          username: JSON.parse(localStorage.getItem('userInfo')).username,
          userRole: JSON.parse(localStorage.getItem('userInfo')).userRole,
          displayName: JSON.parse(localStorage.getItem('userInfo')).displayName,
        },
      };
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.meta = JSON.parse(data.meta);
      self.popupTitle = `Update Vessel ${self.meta.name}`;
      self.meta.id = data.id;
      self.popupActive = true;
    },
    getData() {
      const self = this;
      axios
        .post(
          `https://api.igeotechgps.com/api-vms/get-profiles/${self.userInfo.uid}/${self.userInfo.userRole}/Vessel`,
          {
            adtlAccess: self.userInfo.access.actions.includes('vessel-agency'),
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    postData(type, data) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      let profile = 'Vessel';
      if (type == `add`) {
        url = `https://api.igeotechgps.com/api-vms/add-profile`;
        successText = `Note: Newly added ${profile} could take upto 2 hours to activate alerts`;
        successTitle = `Added New ${profile}`;
        failureText = `Could not add ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `update`) {
        url = `https://api.igeotechgps.com/api-vms/update-profile`;
        successText = `Note: Updated ${profile} configurations could take upto 2 hours to activate alerts`;
        successTitle = `Updated ${profile}`;
        failureText = `Could not Update ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
      }
      if (type == `delete`) {
        url = `https://api.igeotechgps.com/api-vms/delete-profile`;
        successText = `Note: Deleted ${profile} could take upto 2 hours to de-activate alerts`;
        successTitle = `Deleted ${profile}`;
        failureText = `Could not delete ${profile}, pls try again later OR Contact Igeotechgps Account Manager for assistance.`;
        const text = `${profile} deletion action is PERMANENT & IRREVERSIBLE. Continue? `;
        if (confirm(text) == false) {
        }
      }
      if (type == `add` || type == `update`) {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(
              url,
              successText,
              successTitle,
              failureText,
              profile,
            );
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: `warning`,
            });
          });
      } else {
        self.confirmPostData(
          url,
          successText,
          successTitle,
          failureText,
          profile,
          data,
        );
      }
    },
    confirmPostData(
      url,
      successText,
      successTitle,
      failureText,
      profile,
      data,
    ) {
      const self = this;
      let meta;
      if (data) {
        meta = JSON.parse(data.meta);
      } else {
        meta = self.meta;
      }
      axios
        .post(url, {
          userInfo: self.userInfo,
          type: profile,
          meta: meta,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'vesselTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Vessels - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.vesselTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'vesselTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Vessels - Listing.pdf',
        };
        this.$refs.vesselTemplateGrid.pdfExport(exportProperties);
      }
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('events-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-events/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                } else if (response.data.error) {
                } else {
                }
              });
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  watch: {},
  mounted() {
    const self = this;
    const obj = {
      assetName: 'New Vessel Profile',
      assetId: -1,
      assetGroup: 'NEW',
    };
    this.unitSelection.unshift(obj);
    this.getData();
    this.getData2();
    self.initial = false;
  },
};
</script>

<style>
.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}

#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
